export default __webpack_public_path__ + "static/media/brain.87f66404.png";